<app-navbar-cmp></app-navbar-cmp>
<div class="wrapper">
  <div class="cd-section">
    <div class="header-3">
      <div id="carouselExampleIndicators" class="carousel slide">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
        </ol>
        <div class="carousel-inner" role="listbox">
          <div class="carousel-item active">
            <div class="page-header header-filter">
              <div class="page-header-image" style="background-image: url('../../../assets/projects/reizcondo/image_6.JPG');"></div>
              <div class="container">
                <div class="content-center">
                  <div class="row">
                    <div class="col-md-6 text-left">
                      <h1 class="title">Reiz Condo.</h1>
                      <!--<h4 class="description ">According to the National Oceanic and Atmospheric Administration, Ted Scambos, NSIDC lead scientist, puts the potentially record low maximum sea ice extent this year down to low ice extent in the Pacific and a late drop in ice extent in the Barents Sea.</h4>
                      --><br />
                      <div class="buttons">
                        <a [routerLink]="['/project/reiz_condo']" class="btn btn-primary btn-lg mr-1">
                          <i class="now-ui-icons files_single-copy-04"></i> View Shots
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="page-header header-filter">
              <div class="page-header-image" style="background-image: url('../../../assets/projects/padanggolf/image_8.JPG');"></div>
              <div class="container">
                <div class="content-center">
                  <div class="row">
                    <div class="col-md-6 offset-md-6 text-right">
                      <h1 class="title">Padang Golf.</h1>
                      <!--<h4 class="description ">According to the National Oceanic and Atmospheric Administration, Ted Scambos, NSIDC lead scientist, puts the potentially record low maximum sea ice extent this year down to low ice extent in the Pacific and a late drop in ice extent in the Barents Sea.</h4>
                      --><br />
                      <div class="buttons">
                        <a [routerLink]="['/project/padanggolf']" class="btn btn-primary btn-lg mr-1">
                          <i class="now-ui-icons files_single-copy-04"></i> View Shots
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="page-header header-filter">
              <div class="page-header-image" style="background-image: url('../../../assets/projects/mutiararesidence/image_2.JPG');"></div>
              <div class="container">
                <div class="content-center">
                  <div class="row">
                    <div class="col-md-6 text-left">
                      <h1 class="title">Mutiara Residence.</h1>
                      <!--<h4 class="description ">According to the National Oceanic and Atmospheric Administration, Ted Scambos, NSIDC lead scientist, puts the potentially record low maximum sea ice extent this year down to low ice extent in the Pacific and a late drop in ice extent in the Barents Sea.</h4>
                      --><br />
                      <div class="buttons">
                        <a [routerLink]="['/project/mutiararesidence']" class="btn btn-primary btn-lg mr-1">
                          <i class="now-ui-icons files_single-copy-04"></i> View Shots
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="page-header header-filter">
              <div class="page-header-image" style="background-image: url('assets/projects/masdulhak/image_1.JPG');"></div>
              <div class="container">
                <div class="content-center">
                  <div class="row">
                    <div class="col-md-6 offset-md-6 text-right">
                      <h1 class="title">Masdulhak.</h1>
                      <!--<h4 class="description ">According to the National Oceanic and Atmospheric Administration, Ted Scambos, NSIDC lead scientist, puts the potentially record low maximum sea ice extent this year down to low ice extent in the Pacific and a late drop in ice extent in the Barents Sea.</h4>
                      --><br />
                      <div class="buttons">
                        <a [routerLink]="['/project/masdulhak']" class="btn btn-primary btn-lg mr-1">
                          <i class="now-ui-icons files_single-copy-04"></i> View Shots
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="page-header header-filter">
              <div class="page-header-image" style="background-image: url('assets/projects/royalsumatra/image_1.JPG');"></div>
              <div class="container">
                <div class="content-center">
                  <div class="row">
                    <div class="col-md-6 offset-md-6 text-right">
                      <h1 class="title">Royal Sumatra.</h1>
                      <!--<h4 class="description ">According to the National Oceanic and Atmospheric Administration, Ted Scambos, NSIDC lead scientist, puts the potentially record low maximum sea ice extent this year down to low ice extent in the Pacific and a late drop in ice extent in the Barents Sea.</h4>
                      --><br />
                      <div class="buttons">
                        <a [routerLink]="['/project/royalsumatra']" class="btn btn-primary btn-lg mr-1">
                          <i class="now-ui-icons files_single-copy-04"></i> View Shots
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <i class="now-ui-icons arrows-1_minimal-left"></i>
        </a>
        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
          <i class="now-ui-icons arrows-1_minimal-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="main">
    <router-outlet></router-outlet>

    <footer class="footer footer-big" data-background-color="black">
      <div class="container">
        <div class="content">
          <div class="row">
            <div class="col-md-4">
              <h5>About Us</h5>
              <p>PetaMedia merupakan bagian dari PetaRumah yang memiliki komitmen untuk menggerakkan industri properti Indonesia ke arah yang lebih modern melalui fotografi dan teknologi media kreatif yang menarik. </p>
              <p>"Photography is a language that everyone can understand. That's why we don't shoot what it looks like. We shoot what it feels like." </p>
            </div>
            <div class="col-md-4">
              <h5>Contact Us</h5>
              <div class="social-feed">
                <div class="feed-line">
                  <i class="fab fa-whatsapp"></i>
                  <p>0812 6500 1988</p>
                </div>
                <div class="feed-line">
                  <p>team@petarumah.com</p>
                </div>
                <div class="feed-line">
                  <p>Jalan Yos Sudarso Komplek Brayan One Stop Square No. 8AQ, Medan Timur, Sumatera Utara, Indonesia - 20235</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <h5>Instagram Feed</h5>
              <!--<div class="gallery-feed">
                <img src="assets/img/olivia.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/james.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/michael.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/emily.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/marie.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/usher.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/mike.JPG" class="img img-raised rounded" alt="" />
                <img src="assets/img/julie.JPG" class="img img-raised rounded" alt="" />
              </div>-->
            </div>
          </div>
        </div>
        <hr />
        <ul class="pull-left">
          <li>
            <a href="https://petarumah.com" target="_blank">
              PetaRumah
            </a>
          </li>
          <li>
            <a href="https://petarumah.com/about-us" target="_blank">Team PetaRumah</a>
          </li>
          <li>
            <a href="https://www.instagram.com/petarumah/" target="_blank">Instagram</a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCmBtvsu-OO96_x28nRItoHA" target="_blank">Youtube</a>
          </li>
          <!--<li>
            <a href="#pablo">
              Blog
            </a>
          </li>
          <li>
            <a href="#pablo">
              Presentation
            </a>
          </li>
          <li>
            <a href="#pablo">
              Discover
            </a>
          </li>
          <li>
            <a href="#pablo">
              Payment
            </a>
          </li>
          <li>
            <a href="#pablo">
              Contact Us
            </a>
          </li>-->
        </ul>
        <div class="copyright pull-right">
          Copyright &copy;
          {{ getFullYear() }} PetaRumah All Rights Reserved.
        </div>
      </div>
    </footer>
  </div>
</div>
